import {
    ResultItemDetailValue,
    SonoraContact,
    SonoraEntityType,
    SonoraItem,
    SonoraResultDetailItemsType,
} from 'owa-editor-sonora-types';
import loc from 'owa-localize';
import {
    SonoraContactsEmptyPrimaryText,
    SonoraContactsEmptySecondaryText,
} from '../SonoraItemResults.locstring.json';
import * as sonoraCommonStyles from '../../components/SonoraCommonStyles.scss';
import { getLocalizedAddress } from 'owa-location-display-text';

export const getPrimaryTextForSonoraResultsContactItems = (sonoraItem: SonoraContact): string => {
    return sonoraItem.displayName ?? loc(SonoraContactsEmptyPrimaryText);
};

export const getSecondaryTextForSonoraResultsContactItems = (sonoraItem: SonoraContact): string => {
    return sonoraItem.emailAddresses?.[0]?.Name ?? loc(SonoraContactsEmptySecondaryText);
};

export const getTooltipStringForSonoraResultsContactItems = (sonoraItem: SonoraContact): string => {
    const tooltipString: string = [sonoraItem.displayName, sonoraItem.emailAddresses?.[0]?.Name]
        .filter(str => str)
        .join('\n');

    return tooltipString;
};

export const insertContactSuggestionsIntoComposeEditor = (
    sonoraItem: SonoraContact,
    insertNodeCallback: (nodeToInsert: HTMLElement) => void
): void => {
    // Copied styling from createInlineFromPersona in SonoraMentionsPluginDataProvider.
    const anchorElement = document.createElement('a');
    const targetName = sonoraItem?.displayName;
    anchorElement.id = sonoraItem?.id; // Required for AtMentions
    anchorElement.innerText = '@' + targetName;
    anchorElement.className = sonoraCommonStyles.mentionsCompose + ' mention ms-bgc-nlr ms-fcl-b';
    const email = sonoraItem.emailAddresses?.[0]?.Name;
    anchorElement.href = 'mailto:' + email;
    insertNodeCallback(anchorElement);
};

export const insertContactDetailsIntoComposeEditor = (
    primaryText: string,
    insertNodeCallback: (nodeToInsert: HTMLElement) => void
): void => {
    const spanNode = document.createElement('span');
    spanNode.innerText = primaryText;
    insertNodeCallback(spanNode);
};

export const getDetailsMenuValues = (
    sonoraItem: SonoraItem
): Map<SonoraResultDetailItemsType, ResultItemDetailValue[]> | undefined => {
    switch (sonoraItem.type) {
        case SonoraEntityType.Contact:
            var emails = (sonoraItem as SonoraContact).emailAddresses;
            var phones = (sonoraItem as SonoraContact).phoneNumbers;
            var addresses = (sonoraItem as SonoraContact).addresses;
            var contactsDetailsMap = new Map();

            if (emails) {
                let emailValues: ResultItemDetailValue[] = emails?.map(email => {
                    return <ResultItemDetailValue>{
                        icon: SonoraResultDetailItemsType.Emails,
                        primaryText: email?.Name ?? '',
                        // Do not display MailboxType if 'Unknown' because it is not useful information
                        secondaryText:
                            (email?.MailboxType === 'Unknown' ? '' : email?.MailboxType) ?? '',
                    };
                });
                contactsDetailsMap.set(SonoraResultDetailItemsType.Emails, emailValues);
            }

            if (phones) {
                let phoneValues: ResultItemDetailValue[] = phones?.map(phone => {
                    return <ResultItemDetailValue>{
                        icon: SonoraResultDetailItemsType.Phones,
                        primaryText: phone?.Number ?? '',
                        secondaryText: phone?.Type ?? '',
                    };
                });
                contactsDetailsMap.set(SonoraResultDetailItemsType.Phones, phoneValues);
            }

            if (addresses) {
                let addressValues: ResultItemDetailValue[] = addresses?.map(address => {
                    return <ResultItemDetailValue>{
                        icon: SonoraResultDetailItemsType.Addresses,
                        primaryText: getLocalizedAddress(address?.Value),
                        secondaryText: address?.Value?.Type ?? '',
                    };
                });
                contactsDetailsMap.set(SonoraResultDetailItemsType.Addresses, addressValues);
            }

            return contactsDetailsMap;
        default:
            return undefined;
    }
};
